var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Numbers/Number 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8442 4.10147C18.3425 4.30785 18.6673 4.79403 18.6673 5.33331V26.6666C18.6673 27.403 18.0704 28 17.334 28C16.5976 28 16.0007 27.403 16.0007 26.6666V8.55226L11.6101 12.9428C11.0894 13.4635 10.2452 13.4635 9.72451 12.9428C9.20381 12.4221 9.20381 11.5779 9.72451 11.0572L16.3912 4.3905C16.7725 4.00917 17.346 3.8951 17.8442 4.10147Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/Number 1.3674c3a0f7e4fa68c2326eb0b66b3580.svg";
export { ForwardRef as ReactComponent };